import clsx from 'clsx';
import { useTheme, type ThemePreference } from './theme.js';

const OPTIONS: Array<{ value: ThemePreference; label: string; icon: string }> = [
  { value: 'light', label: 'Light', icon: '☀' },
  { value: 'system', label: 'System', icon: '⌧' },
  { value: 'dark', label: 'Dark', icon: '☾' },
];

export function ThemeToggle(): JSX.Element {
  const { preference, setPreference } = useTheme();
  return (
    <div
      role="group"
      aria-label="Theme"
      className="inline-flex overflow-hidden rounded-md border border-slate-300 bg-white text-xs dark:border-slate-700 dark:bg-slate-800"
    >
      {OPTIONS.map((o) => {
        const active = preference === o.value;
        return (
          <button
            key={o.value}
            type="button"
            onClick={() => setPreference(o.value)}
            className={clsx(
              'px-2 py-1 font-medium transition',
              active
                ? 'bg-brand-600 text-white'
                : 'text-slate-600 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-slate-700',
            )}
            aria-pressed={active}
            title={o.label}
          >
            <span aria-hidden="true">{o.icon}</span>
            <span className="sr-only">{o.label}</span>
          </button>
        );
      })}
    </div>
  );
}
